module.exports = __webpack_public_path__ + "static/media/Oktoberfest.61cfda28.jpg";